var loadingPosts = { all: false, except_lesson_posts: false, lesson_posts: false };

window.addEventListener('scroll', function() {
  const activeLink = document.querySelector(".post-filter-nav-link.active");
  if (!activeLink) return;

  var offset = 2000;
  var postType = activeLink.getAttribute("data-type");
  
  if (!loadingPosts[postType]) {
    const docHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (docHeight - windowHeight <= scrollTop + offset) {
      const listEl = document.getElementById("post-list-" + postType);
      if (!listEl) return;

      var page = listEl.getAttribute("data-page");
      var more = listEl.getAttribute("data-more") === "true";
      var hashtag = listEl.getAttribute("data-hashtag");
      var type = listEl.getAttribute("data-type");
      
      var link = `posts/list/${type}?p=${parseInt(page) + 1}`;

      if (hashtag) {
        link += "&h=" + hashtag;
      }

      if (!more) return;

      loadingPosts[postType] = true;
      document.querySelectorAll(".loading-posts").forEach(el => el.style.display = 'block');

      fetch(link)
        .then(res => {
          loadingPosts[postType] = false;
          document.querySelectorAll(".loading-posts").forEach(el => el.style.display = 'none');
        })
        .catch(() => {
          document.querySelectorAll(".loading-posts").forEach(el => el.style.display = 'none');
        });
    }
  }
});

document.addEventListener("turbo:load", () => {
  // Handle modals defensively via jQuery if loaded
  if (window.jQuery) {
    if (document.querySelector(".signup-modal.not-seen")) {
      window.jQuery(".signup-modal").modal({
        backdrop: "static",
        show: true
      });
    }

    if (document.querySelector(".trial-notification-modal")) {
      window.jQuery(".trial-notification-modal").modal({
        show: true
      });
    }

    // Initialize carousels defensively via jQuery if loaded

    if (document.querySelector('.top-banner-carousel')) {
      window.jQuery(".top-banner-carousel").owlCarousel({
        loop: true,
        nav: false,
        center: true,
        margin: 15,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        stagePadding: 100,
        responsive:{
          0: {
            items: 1,
            stagePadding: 0,
            margin: 0
          },
          601: {
            items: 1,
            stagePadding: 50
          },
          1501: {
            items: 2
          }
        }
      });
    }
  }

  const testEl = document.getElementById("teste");
  if (testEl) {
    testEl.addEventListener("click", function() {
      console.log("clicou");
    });
  }
});
